import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import useStore from '~/store';
import { formatSellerName } from '~/utils/sellerName';

export type JourneyAttribution = {
  clubName: string | null;
  sellerName: string | null;
};

/**
 * Dados da faixa de atribuição do Figma 2026 (clube à esquerda, vendedor à direita).
 *
 * O clube vem da store (`planOptions.club.club_name`, preenchido pela rota `flow`)
 * e o vendedor do query param `?channel=`, com as palavras separadas por underscore.
 */
export function useJourneyAttribution(): JourneyAttribution {
  const [searchParams] = useSearchParams();
  const clubName = useStore((store) => store.planOptions?.club?.club_name);
  const sellerName = useMemo(() => formatSellerName(searchParams.get('channel')), [searchParams]);

  return { clubName: clubName || null, sellerName };
}
